const styles = {
  imageWrapper: 'overflow-hidden rounded-2',
  title:
    'mt-2 text-body2 text-gray-3 font-semibold line-clamp-3 md:line-clamp-2',
};

export default styles;
